export default "__VITE_ASSET__DIS6VQTZ__"